import * as HttpService from "../../../../service/HttpService";


/**
 *查询空调经济模型列表
 */
export const queryAirList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/airModel/queryAirList", params);
};

/**
 *查询空调经济模型列表
 */
export const queryDeviceList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/airModel/queryDeviceList", params);
};

/**
 *查询空调经济模型列表
 */
export const addAir = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/airModel/addAir", params);
};

/**
 * 删除空调经济模型
 */
export const deleteAir = (params) => {
    return HttpService.get(HttpService.DOMAIN + "/airModel/deleteAir?id="+params);
};